import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const IssueErrorSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.1028 21.6524H14.8885C16.2274 21.6524 16.7976 21.2138 17.4682 20.4929L21.1997 16.411C21.8357 15.7152 22 15.26 22 14.2863V9.71371C22 8.74002 21.8357 8.28478 21.1997 7.58893L17.4682 3.50704C16.7976 2.78617 16.2274 2.34753 14.8885 2.34753H9.1028C7.77256 2.34753 7.19373 2.78617 6.53182 3.50704L2.79165 7.58893C2.16431 8.28478 2 8.74002 2 9.71371V14.2863C2 15.26 2.16431 15.7152 2.79165 16.411L6.53182 20.4929C7.19373 21.2138 7.77256 21.6524 9.1028 21.6524ZM9.5413 20.263C8.47508 20.263 8.1907 20.0207 7.58736 19.3758L4.07364 15.555C3.68089 15.1198 3.59288 14.8575 3.59288 14.134V9.86595C3.59288 9.14245 3.68089 8.88019 4.07364 8.44495L7.58736 4.62419C8.1907 3.97925 8.47508 3.73699 9.5413 3.73699H14.45C15.5249 3.73699 15.8093 3.97925 16.4126 4.62419L19.9177 8.44495C20.3191 8.88019 20.4071 9.14245 20.4071 9.86595V14.134C20.4071 14.8575 20.3191 15.1198 19.9177 15.555L16.4126 19.3758C15.8093 20.0207 15.5249 20.263 14.45 20.263H9.5413ZM11.9937 13.7692C12.4174 13.7692 12.6646 13.5142 12.6732 13.0576L12.7968 7.82514C12.8055 7.36853 12.459 7.03549 11.985 7.03549C11.5111 7.03549 11.1733 7.35985 11.1819 7.81646L11.3055 13.0576C11.3142 13.5142 11.5614 13.7692 11.9937 13.7692ZM11.9937 16.8955C12.5279 16.8955 12.9827 16.4636 12.9827 15.9411C12.9827 15.4022 12.5366 14.9868 11.9937 14.9868C11.4547 14.9868 11.0134 15.4108 11.0134 15.9411C11.0134 16.4549 11.4634 16.8955 11.9937 16.8955Z"
        fill={color}
      />
    </svg>
  );
};

export { IssueErrorSvg };
